/** @format */

export const calcWhatsappNumber = (countryCode: string) => {
  if (!countryCode) return null;

  if (['ESP', 'ES'].includes(countryCode)) {
    return '34661905477';
  }
  if (['IT', 'ITA'].includes(countryCode)) {
    return '393456414025';
  }

  if (['FRA', 'FR'].includes(countryCode)) {
    return '33745884136';
  }

  if (['PRT', 'PT'].includes(countryCode)) {
    return '351962636011';
  }

  return null;
};
